const BaseUrl = "https://api-examinationsystem.herokuapp.com/student"
// const BaseUrl = "http://34.100.132.195/student"
// const BaseUrl = "http://localhost:4000/student"

const BaseSocketUrl = "https://api-examinationsystem.herokuapp.com/exam"
// const BaseSocketUrl = "http://34.100.132.195/exam"
// const BaseSocketUrl = "http://localhost:4000/exam"

export {
    BaseUrl,
    BaseSocketUrl
}